import {SectionItem} from '../../../components/items-menu/types';
import {PropertyType, ResourceType} from '../../../widgets/property-filter-menu/models/types';
import {TimeUnit, SpecialTimeUnit} from '../../../widgets/date-range-picker/models/types';
import {CustomProperty} from 'common/report/stores/custom-properties';

export enum PropertyItemAction {
  Typecast = `typecast`,
}

export interface PropertyItem extends SectionItem {
  customPropertyId?: {id: number};
  customProperty?: CustomProperty;
  dataGroupId?: string;
  propertyDefaultType: PropertyType;
  resourceType: ResourceType;
  pillAction?: PropertyItemAction;
  type: PropertyType;
  createdBy?: {id: number};
  hidden?: boolean;
  locked?: boolean;
  unit?: TimeUnit | SpecialTimeUnit;
  items?: [any];
}

export const PropertyItemKeys: Array<keyof PropertyItem> = [
  `customPropertyId`,
  `customProperty`,
  `dataGroupId`,
  `label`,
  `propertyDefaultType`,
  `resourceType`,
  `type`,
  `value`,
  `unit`,
  `items`,
];

// Checked in order
export const PropertyItemPersistedIdentifierKeys: Array<keyof PropertyItem> = [
  `customPropertyId`,
  `dataGroupId`,
  `value`,
];

export enum PropertyCombineMode {
  Union = `union`,
  Intersection = `intersection`,
}

// selectedTab be become a B2B property group
export type SelectedTab = `all` | string | ResourceType;

export interface PropertiesMenu {
  useMultipleSelection: boolean;

  getSelectedTab(): SelectedTab;
  isContentSearchable(): boolean;
  isInnerContentSearchable(): boolean;
}
